import {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
// -
import {MiniQ2ValuesModel, MiniQ2HasModel} from "./models/MiniQ2Models";
import useCustomTranslation from "core/customTranslation";
import translations from "../../translations";

const MiniQ2Form = ({item}) => {
    const {t: _Tf} = useTranslation("forms");
    const {t: _TC} = useCustomTranslation(translations);
    const [values, setValues] = useState({...MiniQ2ValuesModel});
    const [has, setHas] = useState({...MiniQ2HasModel});
    const styleCenterMiddle = {textAlign: "center", verticalAlign: "middle"};


    useEffect(() => {
        if (item.id) {
            setValues({...item.values});
            setHas({...item.has});
        } else {
            setValues({...MiniQ2ValuesModel});
            setHas({...MiniQ2HasModel});
        }
    }, [item]);

    const intervalProps = (mode) => {
        switch (mode) {
            case "1":
                return {min: 1, max: 30, step: "1"};
            case "2":
                return {min: 1, max: 24, step: "1"};
            default:
                return {min: 0, max: 0, step: "1"};
        }
    }

    const changeInput = (e) => {
        const {name, value} = e.target;
        setValues({...values, [name]: value});
    }


    return (
        <div className="row">
            <div className="col-12 mb-5">
                <table className="table table-striped mb-5">
                    <thead>
                    <tr>
                        <th>{_Tf("common.name")}</th>
                        <th>{_Tf("common.description")}</th>
                        <th className="text-center">{_Tf("common.parameters")}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>{_TC("mode")}</td>
                        <td>{_TC("mode.description")}</td>
                        <td>
                            <div className="row">
                                <div className="col-md-7">
                                    <div className="text-md-end mt-2">
                                        <label htmlFor="mode" className="form-label">{_TC("mode")}</label>
                                    </div>
                                </div>
                                <div className="col-md-5 d-flex align-items-center">
                                    <select className="form-control" id="mode" name="mode"
                                            onChange={changeInput}
                                            value={values.mode}
                                    >
                                        <option value="0">{_TC("mode.choices.0")}</option>
                                        <option value="1">{_TC("mode.choices.1")}</option>
                                        <option value="2">{_TC("mode.choices.2")}</option>
                                    </select>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>{_TC("time")}</td>
                        <td>{_TC("time.description")}</td>
                        <td>
                            <div className="row">
                                <div className="col-md-7">
                                    <div className="text-md-end mt-2">
                                        <label htmlFor="time" className="form-label">{_TC("time")}</label>
                                    </div>
                                </div>
                                <div className="col-md-5 d-flex align-items-center">
                                    <input
                                        type="number"
                                        id="time"
                                        name="time"
                                        className="mb-2 form-control text-end"
                                        title={_TC("time")}
                                        value={values.time}
                                        onChange={changeInput}
                                        min="0"
                                        max="1439"
                                        step="1"
                                        disabled={values.mode === "0"}
                                    />
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>{_TC("interval")}</td>
                        <td>{_TC("interval.description")}</td>
                        <td>
                            <div className="row">
                                <div className="col-md-7">
                                    <div className="text-md-end mt-2">
                                        <label htmlFor="interval" className="form-label">{_TC("interval")}</label>
                                    </div>
                                </div>
                                <div className="col-md-5 d-flex align-items-center">
                                    <input
                                        type="number"
                                        id="interval"
                                        name="interval"
                                        className="mb-2 form-control text-end"
                                        title={_TC("interval")}
                                        value={values.interval}
                                        onChange={changeInput}
                                        disabled={values.mode === "0"}
                                        {...intervalProps(values.mode)}
                                    />
                                </div>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>

            </div>
        </div>
    )
}
export default MiniQ2Form